import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const TrainOutline = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M12.3134 22.875H19.0354M12.1395 8.125L19.2771 8.125M23.1742 19.7355V9.51047C23.1742 7.5716 21.5128 6 19.4622 6H11.8862C9.83647 6 8.17422 7.5716 8.17422 9.51047V19.7355C8.17422 21.2054 9.30529 22.43 10.7876 22.6738L8.4596 26H10.5294L11.4849 24.6343H19.8644L20.8198 26H22.8892L20.5617 22.6738C22.0435 22.4297 23.1742 21.2054 23.1742 19.7355ZM10.5257 10.851C10.5257 10.4102 10.9031 10.0527 11.3692 10.0527H19.9796C20.4453 10.0527 20.8234 10.4102 20.8234 10.851V14.2184C20.8234 14.6592 20.4453 15.0164 19.9796 15.0164H11.3693C10.9032 15.0164 10.5258 14.6592 10.5258 14.2184L10.5257 10.851ZM11.3292 20.6095C10.7857 20.6095 10.3451 20.1928 10.3451 19.6791C10.3451 19.1648 10.7857 18.748 11.3292 18.748C11.8728 18.748 12.3134 19.1648 12.3134 19.6791C12.3134 20.1928 11.8728 20.6095 11.3292 20.6095ZM20.0196 20.6095C19.4761 20.6095 19.0354 20.1928 19.0354 19.6791C19.0354 19.1648 19.4761 18.748 20.0196 18.748C20.5631 18.748 21.0038 19.1648 21.0038 19.6791C21.0038 20.1928 20.5631 20.6095 20.0196 20.6095Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper strokeWidth={1} {...props} variant="outline" viewBox="0 0 32 32">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { TrainOutline };